import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { SocketService } from '@service/socket.service';
import { OperationsHistoryData } from 'ops/common/models/operations-history-data';
import { Observable, lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class OperationsHistoryService {
    private domain: string;

    public operationsHistoryArray: OperationsHistoryData[] = [];
    public OperationsDatas: OperationsHistoryData[] = [];

    constructor(
        private http: HttpClient,
        private socketService: SocketService,
    ) {
        this.domain = EndPointApi.iApiDomain();
    }

    getOperationsHistoryDataAPI(): Promise<any> {
        return lastValueFrom(this.http.get(`${this.domain}/api/histories/operations`));
    }
}
